module.exports = __webpack_public_path__ + "static/media/organization-icon.2add2946.svg";